export default __webpack_public_path__ + "static/media/1583.5e631809.png";